import gql from 'graphql-tag';

export const planFragment = gql`
  fragment plan on Plan {
    id
    active
    nickname
    product
  }
`;
export const priceFragment = gql`
  fragment price on Price {
    id
    active
    created
    currency
    nickname
    product
    unitAmount
    unitAmountDecimal
  }
`;

export const cardFragment = gql`
  fragment card on Card {
    brand
    expMonth
    expYear
    last4
  }
`;

export const paymentMethodFragment = gql`
  fragment paymentMethod on PaymentMethod {
    id
    card {
      ...card
    }
    type
    created
  }
  ${cardFragment}
`;

export const invoiceFragment = gql`
  fragment invoice on Invoice {
    id
    created
    hostedInvoiceUrl
    paid
    periodStart
    periodEnd
    status
  }
`;

export const invoiceSettingsFragment = gql`
  fragment invoiceSettings on InvoiceSettings {
    defaultPaymentMethod {
      ...paymentMethod
    }
  }
  ${paymentMethodFragment}
`;

export const customerFragment = gql`
  fragment customer on Customer {
    id
    currency
    delinquet
    invoiceSettings {
      ...invoiceSettings
    }
  }
  ${invoiceSettingsFragment}
`;

export const subscriptionItemFragment = gql`
  fragment subscriptionItem on SubscriptionItem {
    id
    created
    plan {
      ...plan
    }
    price {
      ...price
    }
    quantity
  }
  ${planFragment}
  ${priceFragment}
`;

export const subscriptionItemsFragment = gql`
  fragment subscriptionItems on SubscriptionItems {
    data {
      ...subscriptionItem
    }
    hasMore
  }
  ${subscriptionItemFragment}
`;

export const metadataMapFragment = gql`
  fragment metadataMap on MetadataMap {
    itunesId
    showId
  }
`;

export const subscriptionFragment = gql`
  fragment subscription on Subscription {
    id
    cancelAtPeriodEnd
    currentPeriodStart
    currentPeriodEnd
    customer {
      ...customer
    }
    defaultPaymentMethod {
      ...paymentMethod
    }
    latestInvoice {
      ...invoice
    }
    items {
      ...subscriptionItems
    }
    metadata {
      ...metadataMap
    }
  }
  ${customerFragment}
  ${paymentMethodFragment}
  ${invoiceFragment}
  ${subscriptionItemsFragment}
  ${metadataMapFragment}
`;

export const FETCH_SUBSCRIPTION = gql`
  query FetchSubscription {
    subscription {
      ...subscription
    }
  }
  ${subscriptionFragment}
`;

export const CANCEL_SUBSCRIPTION = gql`
  mutation CancelSubscription {
    cancelSubscription {
      ...subscription
    }
  }
  ${subscriptionFragment}
`;

export const RENEW_SUBSCRIPTION = gql`
  mutation RenewSubscription {
    renewSubscription {
      ...subscription
    }
  }
  ${subscriptionFragment}
`;
